import { defaultTheme } from 'visits-style';

export default {
  ...defaultTheme,
};
